import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../../../component/ui/Button';
import React from 'react';
import { hasPermission } from '../../../../../utils/controller';

const CreatePaymentReceivedHeader = ({
	loading,
	user,
	setIsPaymentReceivedAutoSave,
	setIsExcessPaymentModalOpen,
	handleSubmitPaymentReceived,
	calculateTotalExcessPayment,
}) => {
	//

	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;

	return (
		<div className="header-position-sticky">
			<div className="product-pg-header">
				<p>
					{id ? 'Update ' : 'Create New '}
					Payments Received
				</p>
				<div className="add-product-button">
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						button={id ? 'Update' : 'Save'}
						loader={loading}
						disabled={
							loading ||
							(id
								? !hasPermission('sales.payments_received.edit', user?.role?.role_permissions)
								: !hasPermission('sales.payments_received.create', user?.role?.role_permissions))
						}
						onClick={() => {
							if (calculateTotalExcessPayment().toFixed(2) > 0 && !id) {
								setIsPaymentReceivedAutoSave(false);
								setIsExcessPaymentModalOpen(true);
							} else {
								setIsPaymentReceivedAutoSave(false);
								handleSubmitPaymentReceived(3, false);
							}
						}}
					/>
					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button=""
						close
						onClick={() => navigate(`/user/${suburl}/payments-received`)}
					/>
				</div>
			</div>
		</div>
	);
};
export default CreatePaymentReceivedHeader;
